import * as React from 'react';
import { currentUrl } from '../Url';
import { nukeCache } from '../CurrentPage/cache';
import { nukeAppShell } from '../AppShell/utils';
import { triggerEvent } from '../Root';

const ERROR_PARAM_NAME = 'jserror';

async function nukeServiceWorkerCaches() {
  if (window.caches) {
    try {
      const keys = await window.caches.keys();
      await Promise.all(keys.map(key => window.caches.delete(key)));
    } catch (e) {
      // ignore
    }
  }

  if (navigator.serviceWorker) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
    } catch (e) {
      // ignore
    }
  }
}

class ErrorBoundaryInner extends React.Component {
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (!__DEV__) {
      setTimeout(() => {
        throw error;
      });
    }
    this.forceUpdate(); // This will cause all children to be recreated and remounted
  }

  render() {
    return this.props.children;
  }
}

export default class ErrorBoundary extends React.Component {
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (!__DEV__) {
      setTimeout(() => {
        throw error;
      });
      const url = currentUrl();
      const match = (url.searchParams.get(ERROR_PARAM_NAME) || '').match(/^[0-9]+$/);
      const errorState = match ? +match[0] : 0;

      switch (errorState) {
        case 0:
          url.searchParams.set(ERROR_PARAM_NAME, '1');
          window.location.replace(url.toString());
          break;

        case 1:
          Promise.all([nukeCache(), nukeAppShell(), nukeServiceWorkerCaches()]).then(() => {
            url.searchParams.set(ERROR_PARAM_NAME, '2');
            window.location.replace(url.toString());
          });
          break;

        default:
          triggerEvent({ type: 'scope:fataljserror', error, info });
          break;
      }
    }
  }

  render() {
    return <ErrorBoundaryInner>{this.props.children}</ErrorBoundaryInner>;
  }
}
